import React from 'react';
import './message-steps.less';
import classNames from 'classnames';
import { Steps } from 'antd';
import TickThinIcon from 'assests/icons/tick-thin.icon';

const MessageSteps = ({ title, items, current, status }) => {
  /* eslint-disable */
  const renderSwitch = (type) => {
    switch (type) {
      case 'finish':
        return type;
      case 'error':
        return type;
      default:
        return type;
    }
  }

  /* eslint-disable */
  const MessageStep = ({stepNumber, status, title, icon}) => {
    return <div className={classNames('message-step', `message-step--${status}`)}>
      <div className="message-step__icon">
        { status === 'finish' ? <TickThinIcon /> : icon }
      </div>
      <div className="message-step__label">
        {title}
      </div>
    </div>;
  }

  return <div className="message-steps">
    <Steps current={current} status={status}>
      {items && items.map((item,index) => {
        return <MessageStep key={index} title={item.text} icon={item.icon}/>
      })}
    </Steps>
  </div>
}

MessageSteps.defaultProps = {
  status: 'process'
}

export default MessageSteps;
